import script from "./ContestDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ContestDetailView.vue?vue&type=style&index=0&id=b32dd3fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b32dd3fe"]])

export default __exports__